import { USER_ADMIN } from '../constants/index';

const window = global.window;

export const getSvocId = () => window?.THDCustomer?.default?.svocID;

export const getUserId = () => window?.THDCustomer?.default?.userID;

export const role = () => window?.THDCustomer?.default?.role;

export const isAdmin = () => role()?.toUpperCase() === USER_ADMIN;